import { DistrictItem } from 'src/types/search/common';

export const filterDistrictItems = (query: string, districts: DistrictItem[]): DistrictItem[] => {
    return districts.filter((district) => district.name.toLowerCase().includes(query.toLowerCase()));
};
